/* eslint-disable react/function-component-definition */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { withTheme } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import bp from '../../../config/breakpoints';
import { withI18n } from '../../../hocs';
import { useSocketContext } from '../../../sockets/context';
import { CellContainerStyled } from './styled';
import { UserIcon, TransferIcon, NewMessageBadge, ChatCellInfo } from '../../atoms';
import images from '../../../assets/images';

const WhatsappIcon = (
  <svg style={{ width: 24, height: 24 }} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z"
    />
  </svg>
);

const MessengerIcon = (
  <svg style={{ width: 24, height: 24 }} version="1.1" viewBox="0 0 224 226">
    <path
      fill="currentColor"
      d="m41.255 185.52v40.2l37.589-21.37c10.478 3.02 21.616 4.65 33.156 4.65 61.86 0 112-46.79 112-104.5 0-57.714-50.14-104.5-112-104.5-61.856 0-112 46.786-112 104.5 0 32.68 16.078 61.86 41.255 81.02z"
    />
    <path fill="#fff" d="m100.04 75.878l-60.401 63.952 54.97-30.16 28.721 30.16 60.06-63.952-54.36 29.632-28.99-29.632z" />
  </svg>
);
const MSTeams = (<svg style={{ width: 24, height: 24 }} viewBox="0 0 24 24">
  <path fill="currentColor" d="M19.19 8.77Q18.73 8.77 18.33 8.6 17.94 8.43 17.64 8.13 17.34 7.83 17.17 7.44 17 7.04 17 6.58 17 6.13 17.17 5.73 17.34 5.33 17.64 5.04 17.94 4.74 18.33 4.57 18.73 4.39 19.19 4.4 19.64 4.39 20.04 4.57 20.44 4.74 20.74 5.04 21.03 5.33 21.21 5.73 21.38 6.13 21.38 6.58 21.38 7.04 21.21 7.44 21.04 7.83 20.74 8.13 20.44 8.43 20.04 8.6 19.64 8.77 19.19 8.77M19.19 5.65Q18.8 5.65 18.5 5.92 18.25 6.19 18.25 6.58 18.25 6.97 18.5 7.25 18.8 7.5 19.19 7.5 19.58 7.5 19.85 7.25 20.13 7 20.13 6.58 20.13 6.19 19.85 5.92 19.58 5.65 19.19 5.65M22 10.33V15Q22 15.63 21.76 16.2 21.5 16.77 21.09 17.19 20.66 17.62 20.09 17.86 19.5 18.11 18.88 18.11 18.5 18.11 18.12 18 17.73 17.93 17.41 17.75 17.17 18.54 16.7 19.19 16.23 19.84 15.6 20.3 14.97 20.76 14.21 21 13.45 21.27 12.63 21.27 11.67 21.27 10.82 20.94 10 20.61 9.32 20 8.66 19.43 8.23 18.64 7.79 17.84 7.66 16.9H2.83Q2.5 16.9 2.24 16.65 2 16.41 2 16.07V7.73Q2 7.39 2.24 7.14 2.5 6.9 2.83 6.9H10Q9.71 6.3 9.71 5.65 9.71 5.04 9.94 4.5 10.16 4 10.56 3.58 10.96 3.19 11.5 2.96 12 2.73 12.62 2.73 13.23 2.73 13.76 2.96 14.29 3.19 14.69 3.58 15.09 4 15.31 4.5 15.54 5.04 15.54 5.65 15.54 6.25 15.31 6.79 15.09 7.32 14.69 7.71 14.29 8.11 13.76 8.34 13.23 8.57 12.62 8.57 12.47 8.57 12.31 8.55 12.16 8.53 12 8.5V9.4H21.06Q21.45 9.4 21.73 9.67 22 9.94 22 10.33M12.63 4Q12.28 4 12 4.11 11.67 4.24 11.44 4.47 11.22 4.7 11.09 5 10.96 5.31 10.96 5.65 10.96 6 11.09 6.3 11.22 6.6 11.44 6.83 11.67 7.05 12 7.19 12.28 7.32 12.63 7.32 12.97 7.32 13.27 7.19 13.57 7.05 13.8 6.83 14.03 6.6 14.16 6.3 14.3 6 14.3 5.65 14.3 5.31 14.16 5 14.03 4.7 13.8 4.47 13.57 4.24 13.27 4.11 12.97 4 12.63 4M7.78 10.18H9.66V8.62H4.34V10.18H6.22V15.18H7.78M16.38 16.27V10.65H12V16.07Q12 16.41 11.76 16.65 11.5 16.9 11.17 16.9H8.92Q9.05 17.57 9.39 18.15 9.73 18.72 10.21 19.14 10.69 19.55 11.31 19.79 11.92 20 12.63 20 13.4 20 14.08 19.73 14.76 19.43 15.28 18.92 15.79 18.41 16.08 17.73 16.38 17.05 16.38 16.27M20.75 15V10.65H17.63V16.36Q17.88 16.61 18.2 16.74 18.5 16.86 18.88 16.86 19.27 16.86 19.61 16.71 19.95 16.56 20.2 16.31 20.46 16.06 20.6 15.71 20.75 15.37 20.75 15Z" />
</svg>);
const WebchatIcon = (
  <svg style={{ width: 24, height: 24 }} focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation" title="Web">
    <path
      fill="currentColor"
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
    />
  </svg>
);
const openUrl = (externalUrl) => {
  window.open(
    externalUrl ||
      'https://www.google.com/url?q=https://eu31.lightning.force.com/lightning/o/Contact/list?filterName%3DRecent&sa=D&source=hangouts&ust=1590488921987000&usg=AFQjCNGtwsqdvus2ySog3_zs1JxGgEASNQ',
    '_blank'
  );
};
const ChatCell = ({ externalUrl, externalId, i18n, profileName, onSelectChat, chatId, chatLabel, dateLastInputMessage, dateLastUserMessage,
  dateLastAgentMessage, selected, newMessages, showTransferIcon, channel, topics, tableSticky }) => {
  const isMediumScreen = useMediaQuery({ query: `(max-width: ${bp.md}px)` });
  let iconChat;
  let labelChatType = '';
  switch (channel) {
    case 'whatsapp':
      iconChat = WhatsappIcon;
      labelChatType = 'WhatsApp';
      break;
    case 'cloudapi':
      iconChat = WhatsappIcon;
      labelChatType = 'WhatsApp';
      break;
    case 'webchat':
      iconChat = WebchatIcon;
      labelChatType = i18n.chats.webchat;
      break;
    case 'messenger':
      iconChat = MessengerIcon;
      labelChatType = 'Messenger';
      break;
    case 'msteams':
      iconChat = MSTeams;
      labelChatType = 'Microsoft Teams';
    break;
    default:
      iconChat = '';
      break;
  }
  const showNewMessageBadge = newMessages > 0 && !selected;
  const { crmIdentifyEnabled } = useSocketContext();
  return (
    <CellContainerStyled
      isTransferring={showTransferIcon}
      isSelected={selected}
      tableSticky={tableSticky}
      className="ts ts-quick ts-ease-in"
      onClick={() => (showTransferIcon ? () => {} : onSelectChat(chatId))}
    >
      <div className="chat-cell">
        <div className="cell-content">
          {/* <UserIcon fill={selected ? '#ffffff' : '#CECECE'} /> */}
          {showNewMessageBadge && <NewMessageBadge />}
          <ChatCellInfo
            title={chatLabel} profileName={profileName}
            dateLastInputMessage={dateLastInputMessage}
            dateLastUserMessage={dateLastUserMessage}
            dateLastAgentMessage={dateLastAgentMessage}
            topics={topics}
          />
          {showTransferIcon ? <TransferIcon className="transfer-icon-holder" fill="#CECECE" /> : null}
        </div>
        <div className="events-wrapper">
          <div className="label-type-chat">
            <div data-tip={labelChatType} className="icon-channel" data-place="left" data-offset="{'left':10}" data-tip-disable={isMediumScreen}>
              {iconChat}
            </div>
            <ReactTooltip type="info" />
          </div>
          {crmIdentifyEnabled && (
            <div className="div_btn_sf">
              <div className="label-type-chat">
                <div data-tip={i18n.chats.sfDetails} data-place="left" data-offset="{'left':10}" data-tip-disable={isMediumScreen}>
                  <button onClick={() => openUrl(externalUrl)} className={externalId ? 'button_green' : 'button_red'} type="button">
                    {externalId ? (
                      <img className="img-icon-sf" src={images.sfGreen} alt="SFGreen" />
                    ) : (
                      <img className="img-icon-sf" src={images.sfRed} alt="SFRed" />
                    )}
                  </button>
                </div>
                <ReactTooltip type="info" />
              </div>
            </div>
          )}
        </div>
      </div>
    </CellContainerStyled>
  );
};

ChatCell.propTypes = {
  profileName: PropTypes.string,
  i18n: PropTypes.object,
  onSelectChat: PropTypes.func,
  chatId: PropTypes.number,
  selected: PropTypes.bool,
  newMessages: PropTypes.number,
  showTransferIcon: PropTypes.bool,
  channel: PropTypes.string,
  externalUrl: PropTypes.string,
  externalId: PropTypes.string,
  chatLabel: PropTypes.string,
  dateLastInputMessage: PropTypes.string,
  dateLastUserMessage: PropTypes.string,
  dateLastAgentMessage: PropTypes.string,
  topics: PropTypes.array,
  tableSticky: PropTypes.bool,
};

export default withTheme(withI18n(ChatCell));
